const SITE_URL = "https://www.kumia.net";

export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "KumIA",
  url: SITE_URL,
  logo: `${SITE_URL}/kumia-logo-green.png`,
  description:
    "Software gastronomico y ecosistema digital para restaurantes. Sistema completo de gamificacion, CRM, pedidos digitales con QR, fidelizacion de clientes y dashboard en tiempo real.",
  email: "soporte@kumia.net",
  sameAs: [
    "https://www.linkedin.com/company/kumia",
    "https://twitter.com/kumia",
    "https://www.instagram.com/kumia.app",
    "https://www.youtube.com/@kumia",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    email: "soporte@kumia.net",
    contactType: "customer support",
    availableLanguage: ["Spanish", "English", "Portuguese"],
  },
});

export const getWebSiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "KumIA",
  url: SITE_URL,
  description:
    "Software gastronomico y ecosistema digital para la gestion de restaurantes con gamificacion, CRM y pedidos digitales",
});

export const getSoftwareApplicationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "KumIA",
  applicationCategory: "BusinessApplication",
  applicationSubCategory: "Restaurant Management Software",
  operatingSystem: "Web",
  description:
    "Software gastronomico para la gestion de restaurantes. Sistema de pedidos con QR, CRM, gamificacion, fidelizacion de clientes, menu digital y dashboard en tiempo real.",
  offers: {
    "@type": "AggregateOffer",
    lowPrice: "500",
    highPrice: "2500",
    priceCurrency: "CLP",
    offerCount: "3",
  },
  featureList: [
    "CRM para restaurantes e Inteligencia de datos",
    "Sistema de pedidos digitales con QR sin mesero",
    "Gamificacion y fidelizacion de clientes",
    "Dashboard de metricas en tiempo real",
    "Menu digital para restaurantes",
    "Marketing automatizado y push notifications",
    "Programa de lealtad con recompensas",
    "Gestion de restaurantes con inteligencia artificial",
  ],
});

export const getBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const getPreSeedOfferSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Offer",
  name: "KumIA Programa Founders - Software para Restaurantes Gratis",
  description:
    "Se parte de los primeros 50 founders de KumIA. 6 meses gratis del software gastronomico con gamificacion, CRM y pedidos digitales para tu restaurante.",
  price: "0",
  priceCurrency: "CLP",
  availability: "https://schema.org/LimitedAvailability",
  url: `${SITE_URL}/preseed`,
  seller: {
    "@type": "Organization",
    name: "KumIA",
  },
});

export const getAboutPageSchema = () => ({
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "Sobre Nosotros - Equipo del Software Gastronomico KumIA",
  description:
    "Conoce al equipo de KumIA. Fundadores con experiencia en tecnologia, gastronomia e inteligencia artificial creando el ecosistema digital para restaurantes.",
  url: `${SITE_URL}/sobre-nosotros`,
  mainEntity: {
    "@type": "Organization",
    name: "KumIA",
    member: [
      {
        "@type": "Person",
        name: "Ludwing Rondon",
        jobTitle: "CEO & Visionary Founder",
      },
      {
        "@type": "Person",
        name: "Nicolas Ubilla",
        jobTitle: "CEO & Co-Founder",
      },
      {
        "@type": "Person",
        name: "Angel Guevara",
        jobTitle: "Chief Technology Officer",
      },
      {
        "@type": "Person",
        name: "Cesar Lorenzo",
        jobTitle: "Chief AI Officer",
      },
    ],
  },
});

export const getPrivacyPolicyPageSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Politica de Privacidad y Seguridad - KumIA",
  description:
    "Politica de privacidad y seguridad de KumIA. Detalles sobre el cumplimiento GDPR, CCPA, certificaciones de proveedores (Google Cloud, Vercel, MercadoPago) y tratamiento de datos personales.",
  url: `${SITE_URL}/privacidad`,
  inLanguage: "es",
  isPartOf: {
    "@type": "WebSite",
    name: "KumIA",
    url: SITE_URL,
  },
  about: {
    "@type": "Thing",
    name: "Privacy Policy",
  },
});

export const getTermsOfServicePageSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Terminos y Condiciones de Uso - KumIA",
  description:
    "Terminos y condiciones de uso de la plataforma KumIA. Definiciones, servicios ofrecidos, derechos y responsabilidades del usuario y del restaurante.",
  url: `${SITE_URL}/terminos`,
  inLanguage: "es",
  isPartOf: {
    "@type": "WebSite",
    name: "KumIA",
    url: SITE_URL,
  },
  about: {
    "@type": "Thing",
    name: "Terms of Service",
  },
});

export const getFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
});
